<template>
  <div style="padding-top:30px">
    <div class="success">
      <!-- -->
      <div style=" position: relative;">
        <img :src="oss+data.style.icon" alt="" style="width:313px;height:183px">
         <div class="tips" :style="'color:'+data.style.textColor">{{data.params.tips}}</div>
      </div>
      <div class="buttom">
        <div class="button" :style="'background-color:'+data.style.color">前往会员中心</div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
export default {
  name: "success",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];

    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.success {
  width: 320px;
  height: 279px;
  margin: 0 auto;
  background-color: #404459;
  border-radius: 10px;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  padding-top: 32px;
  .tips {
    text-align: center;
    font-size: 24px;
    font-weight: 800;
    color: #dab291;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 100%;
    text-align: center;
  }
  img {
    display: block;
    margin: 0 auto;
  }
  .button {
    width: 150px;
    height: 44px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    margin: 0 auto;
    line-height: 44px;
    text-align: center;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #916022;
    background: linear-gradient(270deg, #f8ddb9 0%, #dab291 100%);
    border-radius: 50px;
    margin-top: 10px;
  }
}
</style>